"use strict";

/// <reference types="jquery"/>
/// <reference types="select2"/>
//Gestion Intervenant Admin
$.initGestionIntervenant = function (urlAction) {
    var tableContainer = $(".datatable.gestion-intervenant");
    tableContainer.on("init-values-before-datatable", function (values) {
        var $onlyEmpty = $("#onlyEmpty", tableContainer);
        if ($onlyEmpty.length !== 0) {
            var onlyEmpty = values[$onlyEmpty.data("column")];
            if (onlyEmpty) {
                $("#onlyEmpty", tableContainer).prop("ckecked", JSON.parse(onlyEmpty));
            }
        }
    }).on("add-more-filter", function () {
        $("#onlyEmpty", tableContainer).on("click", function () {
            var $filter = $(this),
                datatable = tableContainer.data("datatable"),
                column = datatable.columns($filter.data("column") + ":name");
            var value = $filter.prop("checked") ? "true" : "false";
            if (column.search() !== value) {
                column.search(value);
            }
            datatable.draw();
        });
    }).on("createdRow", function (e, row, data) {
        var $row = $(row),
            $td = $row.find("td:last"),
            anchor = $("<a/>", {
            "class": "btn btn-outline-dark my-auto",
            href: data["Action"]
        }).text("Détails"),
            button = $("<button/>", {
            type: "button",
            "class": "btn btn-secondary btn-orezo btn-ajout my-auto mr-1 ml-auto",
            "data-aff": data["Id"],
            "data-bc": data["IdBc"],
            "data-aff-code": data["Code"],
            "data-bc-numero": data["NumeroBc"]
        }).text("Ajouter un intervenant");
        $td.html("").append(button).append(anchor);
    }).setDatatable();
    $(".select-entreprises, .select-affaire, .select-inter").select2({
        width: "100%"
    });
    $("body").on("change", ".select-entreprises", function () {
        document.location.href = urlAction + "?idEntreprise=" + $(this).val();
    }).on("click", "button.btn-ajout", function () {
        var $this = $(this),
            $modal = $("div#modalAjout"),
            aff = $this.data("aff"),
            affCode = $this.data("aff-code"),
            bcCode = $this.data("bc-numero"),
            bc = $this.data("bc");
        //$(".select-affaire").val(aff).trigger("change");
        //if (bc) {
        //    $(".select-bc").val(bc);
        //}
        $(".select-inter").select2("val", "");
        var bcTitle = bcCode ? " pour le bon de commande " + bcCode : "";
        $modal.find(".modal-title").html("Ajouter un intervenant sur l'affaire " + affCode + bcTitle);
        $modal.find("button.add-intervenant").attr("data-aff-id", aff);
        $modal.find("button.add-intervenant").attr("data-bc-id", bc);
        $modal.modal("toggle");
    }).on("click", "button.add-intervenant", function () {
        var $this = $(this);
        if ($(".select-inter").val() === "" || $(".select-role").val() === "") {
            return false;
        }
        var aff = $this.data("aff-id"),
            bc = $this.data("bc-id"),
            role = $(".select-role").val(),
            inter = $(".select-inter").val();
        $.ajax({
            url: "/Entreprise/AffectIntervenant",
            type: "post",
            data: {
                idAffaire: aff,
                intervenant: inter,
                idBonCom: bc,
                role: role
            }
        }).done(function (data) {
            document.location.reload();
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Affaire/intervenants.ts
// module id = 598
// module chunks = 0